import { render, staticRenderFns } from "./VariantSifterGlobalEnrichmentTable.vue?vue&type=template&id=7f5b4ec0&scoped=true&"
import script from "./VariantSifterGlobalEnrichmentTable.vue?vue&type=script&lang=js&"
export * from "./VariantSifterGlobalEnrichmentTable.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterGlobalEnrichmentTable.vue?vue&type=style&index=0&id=7f5b4ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5b4ec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f5b4ec0')) {
      api.createRecord('7f5b4ec0', component.options)
    } else {
      api.reload('7f5b4ec0', component.options)
    }
    module.hot.accept("./VariantSifterGlobalEnrichmentTable.vue?vue&type=template&id=7f5b4ec0&scoped=true&", function () {
      api.rerender('7f5b4ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterGlobalEnrichmentTable.vue"
export default component.exports